var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
    'link',
    _vm.themeClass,
    _vm.data.size ? `typo--${_vm.data.size}` : null,
    _vm.disabled ? 'link--disabled' : null,
  ],attrs:{"href":_vm.external ? _vm.url : undefined,"to":!_vm.external ? _vm.url : undefined,"target":_vm.link.target},domProps:{"innerHTML":_vm._s(_vm.title)},on:_vm._d({},[_vm.event,_vm.data.fn])})
}
var staticRenderFns = []

export { render, staticRenderFns }